import "./topbar.css";
import {
  AiOutlineMenu,
  // AiFillMail,
  AiFillBell,
  AiOutlineClose,
  AiFillSetting,
  AiFillMessage
} from "react-icons/ai";
import { HiMiniGiftTop } from "react-icons/hi2";
import { FaRegListAlt, FaRegCreditCard } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import React, { useEffect, useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { VscVerifiedFilled } from "react-icons/vsc";
import AccountBalanceModal from "./AccountBalanceModal";
import propTypes from "prop-types";
import Popup from "./popup/Popup";

export default function TopBar({ 
  unreadNotifications, 
  unreadMessageCount,
  // availableInvites,
  showTopbar,
  setShowTopbar,
  setIsAccountBalanceModalOpen,
  isAccountBalanceModalOpen,

  }) {
  const { user, balance, socket_context, updateBalance } = useContext(AuthContext);
  const iconRef = useRef(null);
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;

  // used to display and error on the popup component
  const [popupMessage, setPopupMessage] = useState("");

  // no scrolling when topbar modal is visable
  // no scrolling when account balance modal is visable
  useEffect(() => {
    if (isAccountBalanceModalOpen || showTopbar){
      const body = document.body;
      // Check if any modal is open
      const modalOpen = isAccountBalanceModalOpen || showTopbar;
      // Toggle a class or directly set style on the body based on modal state
      if (modalOpen) {
        // This style prevents scrolling
        body.style.overflow = 'hidden';
      } else {
        // This style re-enables scrolling
        body.style.overflow = '';
      }
      
      // Cleanup function to ensure scrolling is re-enabled when the component unmounts
      return () => {
        body.style.overflow = '';
      };
    }
  }, [isAccountBalanceModalOpen, showTopbar]); 

    // hook to run getBalance function when component mounts
    useEffect(() => {
      if (user) {
        updateBalance();
      }
    }, [user, updateBalance]);

  // used to get notifications for online users
  useEffect(() => {
    if (socket_context) {
      try {
        // updating the user's balance
        // should only change when someone gives them currency from a link or post
        updateBalance();
      } catch {
        setPopupMessage("error updating the balance, please try again later.");
      }
    }
  }, [socket_context]);

  // Event handler for clicking on the account balance
  const handleAccountBalanceClick = () => {
    if (!user || !user.username) {
      // User is not logged in, navigate to the login page
      setShowTopbar(false);
      navigate("/login");
    } else {
      // User is logged in, handle the logic for showing the account balance modal
      setIsAccountBalanceModalOpen(true);
    }
  };

  // account balance modal close
  const closeModal = () => {
    setIsAccountBalanceModalOpen(false);
  };

  const goToNotifications = () => {
    // setDropdownVisible((prevState) => !prevState);
    setShowTopbar(false);
    if (user) {
      navigate("/notifications");
    } else {
      navigate("/login");
    }
  };

  const toggleTopbar = () => {
    setShowTopbar((prev) => !prev);
  };

  const goToSettings = () => {
    setShowTopbar(false);
    if (user) {
      navigate(`/profile/${user.username}/settings`);
    } else {
      navigate("/login");
    }
  };

  const goHome = () => {
    navigate("/");
  };

  const goToProfile = () => {
    setShowTopbar(false);
    if (user && user.username) {
      navigate(`/profile/${user ? user.username : ""}`);
    } else {
      navigate("/login");
    }
  };

  const goToWishlist = () => {
    setShowTopbar(false);
    navigate(`/wishlist/${user.username}`);
  };

  const goToMessages = () => {
    setShowTopbar(false);
    navigate("/conversations");
  };

  const goToManageSubscription = () => {
    setShowTopbar(false);
    navigate(`/manage-subscription/${user.username}`);
  };

  // const goToAcceptInvite = () => {
  //   setShowTopbar(false);
  //   navigate("/create-invite");
  // };

  return (
    <div className="topbarContainer">

      <div className="toggle-topbar-container">
          <div className="topbar-icon-container">
  
            <div className="left-icon-container">
              <HiMiniGiftTop className="home-topbar-icon" onClick={goHome} />
            </div>
           
           <div className="right-icon-container">
              {showTopbar && !isAccountBalanceModalOpen ? (
                <AiOutlineClose className="show-topbar-icon-top-x" onClick={toggleTopbar} />
              ) : !isAccountBalanceModalOpen ? (
                <AiOutlineMenu className="show-topbar-icon-top" onClick={toggleTopbar} />
              ) : null}
           </div>
         </div>
      </div>
      <Popup
        isPopupOpen={showPopup}
        message={popupMessage}
        button1Text="Close"
        button1Action={() => setShowPopup(false)}
      />
      <div className={`topbar-left-container ${showTopbar ? "visible" : "hidden"}`}>
        <div className="topbar-left-content-wrapper">
          <div className="profile-details-container">
                    <img
                      src={
                        user && user.profilePicture
                          ? user.profilePicture
                          : `${cloudfrontUrl}/static/no-profile-pic.webp`
                      }
                      alt="No Picture"
                      className="topbarImg"
                      onClick={goToProfile}
                    />
                    {user && user.isSubscribed &&
                      <VscVerifiedFilled className="verified-icon"/>
                    }

                  </div>

            <div className="nav-row-container" onClick={goToProfile}>
              <p>Profile</p>
              <div className="nav-icon-container" ref={iconRef}>
                <CgProfile className="profile-icon" />
                {/* set with prop from notifications page */}
              </div>
            </div>

            <div className="nav-row-container" onClick={goToWishlist}>
              <p>Wishlist</p>
              <div className="nav-icon-container" ref={iconRef}>
                <FaRegListAlt className="wishlist-icon" />
                {/* set with prop from notifications page */}
              </div>
            </div>

            <div className="nav-row-container" onClick={goToNotifications}>
              <p>Notifications</p>
              <div className="nav-icon-container" ref={iconRef}>
                <AiFillBell className="notification-bell-icon" />
                  <span className="notif-count-icon ">
                    {unreadNotifications.length}
                  </span>
                {/* set with prop from notifications page */}
              </div>
            </div>

            <div className="nav-row-container" onClick={goToMessages}>
              <p>Messages</p>
              <div className="nav-icon-container">
                <AiFillMessage className="messages-icon" />
                {/* update with the messages notifications */}
                <span className="notif-count-icon ">{unreadMessageCount}</span>
              </div>
            </div>
            {/* <div className="nav-row-container" onClick={goToAcceptInvite}>
              <p>Invites</p>
              <div className="nav-icon-container">
                <AiFillMail className="messages-icon" />
                <span className="notif-count-icon ">{availableInvites}</span>
              </div>
            </div> */}
            <div className="nav-row-container" onClick={goToManageSubscription}>
              <p>Manage Subscription</p>
              <div className="nav-icon-container">
                <FaRegCreditCard className="messages-icon" />
              </div>
            </div>
            <div className="nav-row-container" onClick={goToSettings}>
              <p>Settings</p>
              <div className="nav-icon-container">
                <AiFillSetting className="messages-icon" />
              </div>
            </div>
          <hr className="bottom-line" />
          <div className="account-balance-container">
            <button
              className="account-balance-btn"
              onClick={handleAccountBalanceClick}
            >
              Balance: <br />
              <span>${balance.toFixed(2)}</span>
            </button>
            <p className="balance-instructions">Click to deposit or withdraw</p>
          </div>
        </div>
      </div>
      <AccountBalanceModal
        isModalOpen={isAccountBalanceModalOpen}
        closeModal={closeModal}
        balance={balance}
      />
    </div>
  );
}

TopBar.propTypes = {
  unreadNotifications: propTypes.array,
  unreadMessageCount: propTypes.number,
  availableInvites: propTypes.number,
  showTopbar: propTypes.bool,
  setShowTopbar: propTypes.func,
  isAccountBalanceModalOpen: propTypes.bool,
  setIsAccountBalanceModalOpen: propTypes.func,
};
